<template>
    <div class="app-containerTeach">
      <el-row class="headTop">
        <span v-if="showShop">
        分店：<el-select v-model="params.shopNum"
         class="w150 mr20"
          clearable  placeholder="请选择分店">
          <el-option
          v-for="item in this.shopList"
          :key="item.shopNum"
          :label="item.name"
          :value="item.shopNum"
          ></el-option>
        </el-select>
        </span>
        日期：<el-date-picker
        class="w150 mr20"
          v-model="params.ymd"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="上课日期">
        </el-date-picker>
        课程名：<el-input
          class="w150 mr20"
          placeholder="请输入团课名"
          v-model="params.name"
          clearable>
        </el-input>
        <el-button style="width:100px"   type="primary" icon="el-icon-search"  @click="queryList()">查询</el-button>
    </el-row>
    <el-dialog title="排课"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
          <el-form-item label="上课日期" prop="recorddate">
            <el-date-picker
              v-model="formparams.recorddate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="上课日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="上课教室" prop="classroom">
            <el-select v-model="formparams.classroom" placeholder="请选择">
              <el-option v-for="item in this.roomList"
              :key="item.name"
              :label="item.name"
              :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上课时间">
            <el-time-select
              placeholder="起始时间"
              v-model="startTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:59'
              }">
            </el-time-select>
            <el-time-select
              placeholder="结束时间"
              v-model="endTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:59',
                minTime: startTime
              }">
            </el-time-select>
          </el-form-item>
          <el-form-item label="选择教练" prop="teacherName">
            <el-select v-model="formparams.teacherName" placeholder="请选择">
              <el-option v-for="item in this.optionsJL"
              :key="item.name"
              :label="item.name"
              :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="最大人数" prop="maxRenshu">
            <el-input class="w220" v-model.number="formparams.maxRenshu" placeholder="请输入上课人数"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <!-- <el-table-column prop="courseCode" label="团课编码"></el-table-column> -->
        <el-table-column prop="courseName" label="课程名称"></el-table-column>
        <el-table-column prop="courseType" label="课程类型"></el-table-column>
        <el-table-column prop="recorddate" label="上课日期"></el-table-column>
        <el-table-column prop="classroom" label="上课教室"></el-table-column>
        <el-table-column prop="courseTime" label="上课时间"></el-table-column>
        <el-table-column prop="teacherName" label="教练名称"></el-table-column>
        <el-table-column prop="maxRenShu" label="最大人数"></el-table-column>
        <el-table-column label="分店编号">
          <template slot-scope="scope">
            <div> {{scope.row.shopNum|caseType}} </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="排课说明"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <!-- <el-button style="width:100px"  type="danger" @click="removeList(scope.row.id)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import { getVieWEJt, getTbCourse, getClassInfo, getTbTuancaorec, getShops, updateTuancaorec } from "../../api/configApi";
// import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      showShop:false,
      date:[],//开始时间结束时间
      rules:{
        classroom:[
          { required: true, message: '请选择教室', trigger: 'change' }
        ],
        recorddate:[
          { required: true, message: '请选择时间', trigger: 'change' }
        ],
        teacherName:[
          { required: true, message: '请选择教师', trigger: 'change' }
        ],
        maxRenshu:[
          { required: true, message: '人数不能为空'},
          { type: 'number', message: '人数必须为数字值'}
        ]
      },
      startTime:'',
      endTime:'',
      timeList:[],
      addType:1,
      formparams:{
        code:'',
        recorddate:'',
        classroom:'',
        courseTime:'',
        courseName:'',
        courseType:'',
        teacherName:'',
        maxRenshu:'',
        shopNum:''
      },
      formData:{},
      fileList:[],//图片回显示
      tableData:[],
      optionsJL:[],//私教列表
      classProject:[],//团课项目
      roomList:[],
      titleList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  components: {
    // mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
    this.getShopsList()
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    //查询教室
    getClassInfo(shopNum){
      getClassInfo({shopNum:shopNum}).then((res)=>{
        console.log(res)
        if(res.msg == 'success'){
          this.roomList = res.data
          sessionStorage.setItem('roomList',JSON.stringify(res.data))
          this.showShop = false
        }else{
          this.showShop = true
        }
      })
    },
    queryList(){
      this.params.pageNo = 1;
      this.currentPage = 1;
      this.getTableList()
    },
    //查询排课
    getTableList(){
      getTbTuancaorec(this.params).then((res)=>{
        console.log(res)
        if(res.msg == "success"){
            this.tableData = res.data.info
            this.total = res.data.num
        }
        this.loading = false
      })
    },
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
        sessionStorage.setItem('shopList',JSON.stringify(res.data))
        if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
          this.params.shopNum = this.shopList[0].shopNum
        }
      })
    },
   //查询教练
    getVieWEJt(){
      getVieWEJt({shopNum:this.formparams.shopNum}).then((res)=>{
        console.log(res)
        if(res.msg=='success'){
          this.optionsJL = res.data
          sessionStorage.setItem('optionsJL',JSON.stringify(res.data))
        }else {
          this.$message.error(res.data)
        }
      })
    },
    //编辑
    edit(row){
      console.log(row)
      this.dialogVisible = true
      this.formparams.id = row.id
      this.formparams.code = row.courseCode
      this.formparams.recorddate = row.recorddate
      this.startTime = row.courseTime.split('-')[0]
      this.endTime = row.courseTime.split('-')[1]

      this.formparams.classroom = row.classroom
      this.formparams.courseName = row.courseName
      this.formparams.courseType = row.courseType
      this.formparams.teacherName = row.teacherName
      this.formparams.maxRenshu = parseInt(row.maxRenShu)
      this.formparams.shopNum = row.shopNum
      this.getVieWEJt()
      setTimeout(() => {
        this.getClassInfo(row.shopNum)
      }, 200);
    },
    //添加票
    // insertOnlineTicketInfo
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          this.formparams.courseTime = this.startTime+'-'+this.endTime
            updateTuancaorec(this.formparams).then((res)=>{
              if(res.msg=="success"){
                this.$message({
                  type:'success',
                  message:'修改成功'
                })
              } else{
                this.$message.error(res.data)
              }
              this.dialogVisible = false
              this.getTableList()
            })
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getTableList()
    },
  }
};
</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// classTeacher.vue?1386707b